<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{
          Object.entries(this.data.item).length === 0
            ? $t('NavMenuItem.SystemSection.RolesPage.AddNew')
            : $t('NavMenuItem.SystemSection.RolesPage.Update')
        }}
        {{ $t('NavMenuItem.SystemSection.RolesPage.Item') }}
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :key="$vs.rtl">
      <div class="p-6">
        <!-- ROLE -->
        <vs-input
          v-model="enumData"
          label="Key"
          class="mt-5 w-full"
          name="role-name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('role-name')">{{
          errors.first('role-name')
        }}</span>

        <!-- ACTIVITY -->
        <vs-textarea
          v-model="valueData"
          label="Value"
          class="mt-5 w-full"
          name="role-name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('activity-name')">{{
          errors.first('activity-name')
        }}</span>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{
        $t('NavMenuItem.SystemSection.RolesPage.Submit')
      }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{
        $t('NavMenuItem.SystemSection.RolesPage.Cancel')
      }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dataId: null,
      enumData: null,
      valueData: null
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data.item).length === 0) {
        this.$validator.reset()
      }
      this.initValues()
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.enumData && this.valueData !== ''
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    zipSelectItems(arr) {
      const jsUcfirst = string => string.charAt(0).toUpperCase() + string.slice(1)
      return arr.map((v, i) => Object.assign({}, { text: jsUcfirst(v), value: arr[i] }))
    },
    initValues() {
      if (this.data.item.id) {
        this.dataId = this.data.item.id
        this.enumData = this.data.item.key
        this.valueData = this.data.item.value.join(', ')
      } else {
        this.enumData = null
        this.valueData = null
      }
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            key: this.enumData,
            value: this.valueData.split(',').map(attr => attr.trim())
          }

          if (this.dataId !== null) {
            this.$store.dispatch('enum/editEnum', { id: this.dataId, data: obj }).then(response => {
              this.$notifySuccess(`Enum: ${response.data.key}`, 'Object Edited')
            })
          } else {
            this.$store.dispatch('enum/createEnum', obj).then(response => {
              this.$notifySuccess(`Enum: ${response.data.key}`, 'Object Created')
            })
          }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
